import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Message, MessageService} from "@alpha/services";
import {Subscription} from "rxjs";

@Component({
  selector: 'notice',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss']
})
export class NoticeComponent implements OnDestroy, OnInit {
  constructor(private ms: MessageService) {
  }

  ngOnInit(): void {
    this.messageSub = this.ms.message.subscribe((message: Message) => this.messageListener(message))
  }

  messageSub: Subscription | undefined;
  message?: Message;

  ping: boolean = false;
  active: boolean = false;
  timer: any = null;

  messageListener(message: Message) {
    if (message) {
      this.message = message;
      this.ping = true;
      setTimeout(() => {
        this.active = true;
      }, 500);
      setTimeout(() => {
        this.active = false;
        setTimeout(() => {
          this.ping = false;
        }, 500);
      }, message.delay);
    }
  }

  close() {
    clearTimeout(this.timer);
    setTimeout(() => {
      this.active = false;
      setTimeout(() => {
        this.ping = false;
      }, 500);
    }, 1);
  }

  ngOnDestroy() {
    this.messageSub?.unsubscribe();
  }
}
